import { Channel } from '../../../models';

type EvolutionDiagramTypeConfig = {
  group1?: string[];
  group2?: string[];
  group3?: string[];
  group4?: string[];
  group5?: string[];
  group6?: string[];
  group7?: string[];
  group8?: string[];
};

export const EVOLUTION_DIAGRAM_TYPE_GROUPS_BY_CHANNEL: Record<Channel, EvolutionDiagramTypeConfig> = {
  [Channel.VISITS_1_TO_1]: {
    group1: ['Promotional'], //group1: ['Commercial - Environment'],
    group2: ['Non-Promotional'], //group2: ['Market Access'],
  },
  [Channel.EMAIL]: {
    group1: ['Newsletter'],
    group2: ['Event'],
    group3: ['Other', 'Others'],
  },
  [Channel.WEBSITE]: {
    group1: ['*'], // all / N/A only
  },
  [Channel.EVENT]: {
    group1: ['*'],
  },
};
